export default {
    name: "萌电小宠",
    version: "1.0.1",
    slogan: "咻的一下，能量满满！",
    HOST: "https://fileserver.mdxc.gdcbd.net/files/commonfile/copyright.html",
    agreementUrl: "https://fileserver.mdxc.gdcbd.net/files/commonfile/agreement.html",
    company: "广东城市大数据有限公司",
    cohr: "城市大数据",
    wechatGzh: "萌电小宠",
    website: "em.ruidianchongdian.top",
    tel: "13502208585",
    services: []
};



// WEBPACK FOOTER //
// ./src/Config.js